export const isObject = <Ent,>(obj: Ent) => obj instanceof Object && typeof obj === 'object';
export const sortObjByKey = <Ent,>(obj: Ent): Ent =>
  Object.keys(obj)
    .sort()
    .reduce((accum, val) => ({...accum, [val]: (obj as any)[val]}), {} as Ent);

export const isEqualObjJson = <Ent,>(ent1: Ent, ent2: Ent) => JSON.stringify(sortObjByKey<Ent>(ent1)) === JSON.stringify(sortObjByKey<Ent>(ent2));
export const isEqualJson = <Ent,>(ent1: Ent, ent2: Ent) => {
  if (isObject<Ent>(ent1) && isObject<Ent>(ent2)) return isEqualObjJson<Ent>(ent1, ent2);

  return JSON.stringify(ent1) === JSON.stringify(ent2);
};